module.exports = __webpack_public_path__ + "static/media/icon-excluded-attendant.1a3da11b.svg";